// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --FONT_DEFAULT: InterRegular;
  --FONT_MEDIUM: InterMedium;
  --FONT_SEMIBOLD: InterSemibold;
  --FONT_EXTRABOLD: InterExtraBold;
  --FONT_SIZE_14: 14px;

  --WEIGHT_NORMAL: 500;
  --WEIGHT_400: 400;
  --WEIGHT_600: 600;
  --WEIGHT_700: 700;
  --WEIGHT_900: 900;

  --TRANSITION_03: 0.3s;
  --TRANSITION_05: 0.5s;
  --TRANSITION_1: 1s;
  --TRANSITION_4: 4s;

  --OPACITY_03: 0.3;
  --OPACITY_05: 0.5;
  --OPACITY_09: 0.9;
  --OPACITY_1: 1;

  --FONT_SIZE_SUB_TEXT: 12px;
  --FONT_SIZE_TEXT: 14px;
  --FONT_SIZE_SUB_TITLE: 16px;
  --FONT_SIZE_TEXT_TITLE: 18px;
  --FONT_SIZE_TITLE: 20px;
  --FONT_SIZE_24: 24px;
  --FONT_SIZE_28: 28px;
  --FONT_SIZE_30: 30px;

  --LINE_HEIGHT_14: 14px;
  --LINE_HEIGHT_16: 16px;
  --LINE_HEIGHT_18: 18px;
  --LINE_HEIGHT_20: 20px;
  --LINE_HEIGHT_24: 24px;
  --LINE_HEIGHT_28: 28px;
  --LINE_HEIGHT_32: 32px;
  --LINE_HEIGHT_38: 38px;
  --LINE_HEIGHT_44: 44px;

  --BACKGROUND_PAGE: rgba(252, 252, 253, 1); /* #fcfcfd */

  --COLOR_PRIMARY_25: rgba(252, 250, 255, 1); /* #fcfaff */
  --COLOR_PRIMARY_50: rgba(249, 245, 255, 1); /* #f9f5ff */
  --COLOR_PRIMARY_100: rgba(244, 235, 255, 1); /* #f4ebff */
  --COLOR_PRIMARY_150: rgba(248, 244, 255, 1); /* #f8f4ff */
  --COLOR_PRIMARY_200: rgba(233, 215, 254, 1); /* #e9d7fe */
  --COLOR_PRIMARY_300: rgba(214, 187, 251, 1); /* #d6bbfb */
  --COLOR_PRIMARY_350: rgba(234, 236, 240, 1); /* #eaecf0 */
  --COLOR_PRIMARY_400: rgba(182, 146, 246, 1); /* #b692f6 */
  --COLOR_PRIMARY_500: rgba(158, 119, 237, 1); /* #9e77ed */
  --COLOR_PRIMARY_600: rgba(127, 86, 217, 1); /* #7f56d9 */
  --COLOR_PRIMARY_700: rgba(105, 65, 198, 1); /* #6941c6 */
  --COLOR_PRIMARY_725: rgba(89, 37, 220, 1); /* #5925dc */
  --COLOR_PRIMARY_750: rgba(53, 56, 205, 1); /* #3538cd */
  --COLOR_PRIMARY_800: rgba(83, 56, 158, 1); /* #53389e */
  --COLOR_PRIMARY_850: rgba(208, 213, 221, 1); /* #d0d5dd */
  --COLOR_PRIMARY_900: rgba(66, 48, 125, 1); /* #42307d */
  --COLOR_PRIMARY_950: rgba(52, 64, 84, 1); /* #344054 */

  --COLOR_FOREGROUND: rgba(255, 255, 255, 1); /* #ffffff */

  --COLOR_FAILED: rgba(253, 162, 155, 1); /* #fda29b */
  --COLOR_FAILED_25: rgba(217, 45, 32, 1); /* #d92d20 */
  --COLOR_FAILED_50: rgba(180, 35, 24, 1); /* #b42318 */
  --COLOR_FAILED_75: rgba(255, 251, 250, 1); /* #fffbfa */
  --COLOR_FAILED_100: rgba(2, 121, 72, 1); /* #027948 */
  --COLOR_FAILED_125: rgba(179, 35, 24, 1); /* #b32318 */

  --COLOR_ERROR_50: rgba(254, 243, 242, 1); /* #fef3f2 */
  --COLOR_ERROR_100: rgba(254, 228, 226, 1); /* #fee4e2 */
  --COLOR_ERROR_500: rgba(240, 68, 56, 1); /* #f04438 */

  --COLOR_SUCCESS_500: rgba(18, 183, 106, 1); /* #12b76a */

  --COLOR_GRAY_HOVER: rgba(234, 234, 234, 1); /* #eaeaea */
  --COLOR_GRAY_LIGHT: rgba(229, 229, 229, 1); /* #e5e5e5 */
  --COLOR_GRAY_50: rgba(249, 250, 251, 1); /* #f9fafb */
  --COLOR_GRAY_75: rgba(221, 222, 224, 1); /* #dddee0 */
  --COLOR_GRAY_100: rgba(242, 244, 247, 1); /* #f2f4f7 */
  --COLOR_GRAY_150: rgba(161, 167, 180, 1); /* #a1a7b4 */
  --COLOR_GRAY_400: rgba(152, 162, 179, 1); /* #98a2b3 */
  --COLOR_GRAY_500: rgba(102, 112, 133, 1); /* #667085 */
  --COLOR_GRAY_500_LIGHT: rgba(102, 112, 133, 0.6); /* #667085 */
  --COLOR_GRAY_600: rgba(71, 84, 103, 1); /* #475467 */
  --COLOR_GRAY_800: rgba(29, 41, 57, 1); /* #1d2939 */
  --COLOR_GRAY_900_EXTRALIGHT: rgba(16, 24, 40, 0.03); /* #101828; */
  --COLOR_GRAY_900_LIGHT: rgba(16, 24, 40, 0.05); /* #101828; */
  --COLOR_GRAY_900_HEAVY: rgba(16, 24, 40, 0.08); /* #101828; */
  --COLOR_GRAY_900: rgba(16, 24, 40, 1); /* #101828 */

  --SIZE_BORDER: 1px;
  --SIZE_BORDER_THICK: 2px;
  --SIZE_BORDER_FRAME: 4px;
  --SIZE_TOP_LINE: 6px;
  --MENU_MIN_WIDTH: 240px;
  --MENU_MAX_WIDTH: 648px;
  --CONTENT_MIN_WIDTH: 232px;
  --CONTENT_MAX_WIDTH: 335px;
  --FORM_MAX_WIDTH: 358px;
  --PAGE_MAX_WIDTH: 435px;
  --TEXT_MAX_WIDTH: 472px;
  --MODAL_MAX_WIDTH: 500px;
  --DROPDOWN_MIN_WIDTH: 512px;
  --MODAL_MOBILE: 80vh;
  --MAX_VIEW_HEIGHT: 100vh;
  --MAX_VIEW_WIDTH: 100vw;

  --BORDER_PRIMARY: 1px solid rgba(208, 213, 221, 1);

  --SIZE_1: 1px;
  --SIZE_2: 2px;
  --SIZE_4: 4px;
  --SIZE_5: 5px;
  --SIZE_6: 6px;
  --SIZE_8: 8px;
  --SIZE_9: 9px;
  --SIZE_10: 10px;
  --SIZE_12: 12px;
  --SIZE_15: 15px;
  --SIZE_16: 16px;
  --SIZE_17: 17px;
  --SIZE_18: 18px;
  --SIZE_20: 20px;
  --SIZE_22: 22px;
  --SIZE_24: 24px;
  --SIZE_25: 25px;
  --SIZE_26: 26px;
  --SIZE_28: 28px;
  --SIZE_30: 30px;
  --SIZE_32: 32px;
  --SIZE_33: 33px;
  --SIZE_34: 34px;
  --SIZE_36: 36px;
  --SIZE_37: 37px;
  --SIZE_40: 40px;
  --SIZE_43: 43px;
  --SIZE_44: 44px;
  --SIZE_46: 46px;
  --SIZE_48: 48px;
  --SIZE_50: 50px;
  --SIZE_60: 60px;
  --SIZE_68: 68px;
  --SIZE_70: 70px;
  --SIZE_72: 72px;
  --SIZE_76: 76px;
  --SIZE_80: 80px;
  --SIZE_88: 88px;
  --SIZE_84: 84px;
  --SIZE_90: 90px;
  --SIZE_92: 92px;
  --SIZE_96: 96px;
  --SIZE_100: 100px;
  --SIZE_101: 101px;
  --SIZE_103: 103px;
  --SIZE_112: 112px;
  --SIZE_113: 113px;
  --SIZE_120: 120px;
  --SIZE_124: 124px;
  --SIZE_142: 142px;
  --SIZE_149: 149px;
  --SIZE_158: 158px;
  --SIZE_168: 168px;
  --SIZE_171: 171px;
  --SIZE_174: 174px;
  --SIZE_190: 190px;
  --SIZE_200: 200px;
  --SIZE_206: 206px;
  --SIZE_223: 223px;
  --SIZE_230: 230px;
  --SIZE_240: 240px;
  --SIZE_259: 259px;
  --SIZE_260: 260px;
  --SIZE_275: 275px;
  --SIZE_280: 280px;
  --SIZE_290: 290px;
  --SIZE_295: 295px;
  --SIZE_296: 296px;
  --SIZE_330: 330px;
  --SIZE_378: 378px;
  --SIZE_400: 400px;

  --SIZE_90VW: 90vw;
  --SIZE_90VH: 90vh;

  --RADIUS_4: 4px;
  --RADIUS_5: 5px;
  --RADIUS_6: 6px;
  --RADIUS_8: 8px;
  --RADIUS_10: 10px;
  --RADIUS_12: 12px;
  --RADIUS_16: 16px;
  --RADIUS_20: 20px;
  --RADIUS_28: 28px;
  --RADIUS_40: 40px;
  --RADIUS_50: 50px;

  --MARGIN_2: 2px;
  --MARGIN_3: 3px;
  --MARGIN_4: 4px;
  --MARGIN_6: 6px;
  --MARGIN_7: 7px;
  --MARGIN_8: 8px;
  --MARGIN_9: 9px;
  --MARGIN_10: 10px;
  --MARGIN_11: 11px;
  --MARGIN_12: 12px;
  --MARGIN_14: 14px;
  --MARGIN_16: 16px;
  --MARGIN_17: 17px;
  --MARGIN_18: 18px;
  --MARGIN_20: 20px;
  --MARGIN_23: 23px;
  --MARGIN_24: 24px;
  --MARGIN_25: 25px;
  --MARGIN_28: 28px;
  --MARGIN_29: 29px;
  --MARGIN_30: 30px;
  --MARGIN_32: 32px;
  --MARGIN_36: 36px;
  --MARGIN_38: 38px;
  --MARGIN_40: 40px;
  --MARGIN_44: 44px;
  --MARGIN_50: 50px;
  --MARGIN_56: 56px;
  --MARGIN_60: 60px;
  --MARGIN_76: 76px;
  --MARGIN_116: 116px;

  --PADDING_1: 1px;
  --PADDING_2: 2px;
  --PADDING_3: 3px;
  --PADDING_4: 4px;
  --PADDING_5: 5px;
  --PADDING_6: 6px;
  --PADDING_7: 7px;
  --PADDING_8: 8px;
  --PADDING_9: 9px;
  --PADDING_10: 10px;
  --PADDING_11: 11px;
  --PADDING_12: 12px;
  --PADDING_13: 13px;
  --PADDING_14: 14px;
  --PADDING_15: 15px;
  --PADDING_16: 16px;
  --PADDING_17: 17px;
  --PADDING_18: 18px;
  --PADDING_19: 19px;
  --PADDING_20: 20px;
  --PADDING_23: 23px;
  --PADDING_24: 24px;
  --PADDING_25: 25px;
  --PADDING_26: 26px;
  --PADDING_28: 28px;
  --PADDING_29: 29px;
  --PADDING_30: 30px;
  --PADDING_32: 32px;
  --PADDING_34: 34px;
  --PADDING_40: 40px;
  --PADDING_42: 42px;
  --PADDING_46: 46px;
  --PADDING_48: 48px;
  --PADDING_54: 54px;
  --PADDING_60: 60px;
  --PADDING_67: 67px;
  --PADDING_89: 89px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;;EAEpB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;;EAElB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;;EAEd,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,yCAAyC,EAAE,YAAY;;EAEvD,0CAA0C,EAAE,YAAY;EACxD,0CAA0C,EAAE,YAAY;EACxD,2CAA2C,EAAE,YAAY;EACzD,2CAA2C,EAAE,YAAY;EACzD,2CAA2C,EAAE,YAAY;EACzD,2CAA2C,EAAE,YAAY;EACzD,2CAA2C,EAAE,YAAY;EACzD,2CAA2C,EAAE,YAAY;EACzD,2CAA2C,EAAE,YAAY;EACzD,0CAA0C,EAAE,YAAY;EACxD,0CAA0C,EAAE,YAAY;EACxD,yCAAyC,EAAE,YAAY;EACvD,yCAAyC,EAAE,YAAY;EACvD,yCAAyC,EAAE,YAAY;EACvD,2CAA2C,EAAE,YAAY;EACzD,yCAAyC,EAAE,YAAY;EACvD,wCAAwC,EAAE,YAAY;;EAEtD,0CAA0C,EAAE,YAAY;;EAExD,sCAAsC,EAAE,YAAY;EACpD,uCAAuC,EAAE,YAAY;EACrD,uCAAuC,EAAE,YAAY;EACrD,yCAAyC,EAAE,YAAY;EACvD,uCAAuC,EAAE,YAAY;EACrD,wCAAwC,EAAE,YAAY;;EAEtD,wCAAwC,EAAE,YAAY;EACtD,yCAAyC,EAAE,YAAY;EACvD,uCAAuC,EAAE,YAAY;;EAErD,0CAA0C,EAAE,YAAY;;EAExD,0CAA0C,EAAE,YAAY;EACxD,0CAA0C,EAAE,YAAY;EACxD,uCAAuC,EAAE,YAAY;EACrD,uCAAuC,EAAE,YAAY;EACrD,wCAAwC,EAAE,YAAY;EACtD,wCAAwC,EAAE,YAAY;EACtD,wCAAwC,EAAE,YAAY;EACtD,wCAAwC,EAAE,YAAY;EACtD,gDAAgD,EAAE,YAAY;EAC9D,sCAAsC,EAAE,YAAY;EACpD,qCAAqC,EAAE,YAAY;EACnD,mDAAmD,EAAE,aAAa;EAClE,8CAA8C,EAAE,aAAa;EAC7D,8CAA8C,EAAE,aAAa;EAC7D,qCAAqC,EAAE,YAAY;;EAEnD,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;;EAEvB,kDAAkD;;EAElD,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,iBAAiB;EACjB,iBAAiB;;EAEjB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;;EAEnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[":root {\n  --FONT_DEFAULT: InterRegular;\n  --FONT_MEDIUM: InterMedium;\n  --FONT_SEMIBOLD: InterSemibold;\n  --FONT_EXTRABOLD: InterExtraBold;\n  --FONT_SIZE_14: 14px;\n\n  --WEIGHT_NORMAL: 500;\n  --WEIGHT_400: 400;\n  --WEIGHT_600: 600;\n  --WEIGHT_700: 700;\n  --WEIGHT_900: 900;\n\n  --TRANSITION_03: 0.3s;\n  --TRANSITION_05: 0.5s;\n  --TRANSITION_1: 1s;\n  --TRANSITION_4: 4s;\n\n  --OPACITY_03: 0.3;\n  --OPACITY_05: 0.5;\n  --OPACITY_09: 0.9;\n  --OPACITY_1: 1;\n\n  --FONT_SIZE_SUB_TEXT: 12px;\n  --FONT_SIZE_TEXT: 14px;\n  --FONT_SIZE_SUB_TITLE: 16px;\n  --FONT_SIZE_TEXT_TITLE: 18px;\n  --FONT_SIZE_TITLE: 20px;\n  --FONT_SIZE_24: 24px;\n  --FONT_SIZE_28: 28px;\n  --FONT_SIZE_30: 30px;\n\n  --LINE_HEIGHT_14: 14px;\n  --LINE_HEIGHT_16: 16px;\n  --LINE_HEIGHT_18: 18px;\n  --LINE_HEIGHT_20: 20px;\n  --LINE_HEIGHT_24: 24px;\n  --LINE_HEIGHT_28: 28px;\n  --LINE_HEIGHT_32: 32px;\n  --LINE_HEIGHT_38: 38px;\n  --LINE_HEIGHT_44: 44px;\n\n  --BACKGROUND_PAGE: rgba(252, 252, 253, 1); /* #fcfcfd */\n\n  --COLOR_PRIMARY_25: rgba(252, 250, 255, 1); /* #fcfaff */\n  --COLOR_PRIMARY_50: rgba(249, 245, 255, 1); /* #f9f5ff */\n  --COLOR_PRIMARY_100: rgba(244, 235, 255, 1); /* #f4ebff */\n  --COLOR_PRIMARY_150: rgba(248, 244, 255, 1); /* #f8f4ff */\n  --COLOR_PRIMARY_200: rgba(233, 215, 254, 1); /* #e9d7fe */\n  --COLOR_PRIMARY_300: rgba(214, 187, 251, 1); /* #d6bbfb */\n  --COLOR_PRIMARY_350: rgba(234, 236, 240, 1); /* #eaecf0 */\n  --COLOR_PRIMARY_400: rgba(182, 146, 246, 1); /* #b692f6 */\n  --COLOR_PRIMARY_500: rgba(158, 119, 237, 1); /* #9e77ed */\n  --COLOR_PRIMARY_600: rgba(127, 86, 217, 1); /* #7f56d9 */\n  --COLOR_PRIMARY_700: rgba(105, 65, 198, 1); /* #6941c6 */\n  --COLOR_PRIMARY_725: rgba(89, 37, 220, 1); /* #5925dc */\n  --COLOR_PRIMARY_750: rgba(53, 56, 205, 1); /* #3538cd */\n  --COLOR_PRIMARY_800: rgba(83, 56, 158, 1); /* #53389e */\n  --COLOR_PRIMARY_850: rgba(208, 213, 221, 1); /* #d0d5dd */\n  --COLOR_PRIMARY_900: rgba(66, 48, 125, 1); /* #42307d */\n  --COLOR_PRIMARY_950: rgba(52, 64, 84, 1); /* #344054 */\n\n  --COLOR_FOREGROUND: rgba(255, 255, 255, 1); /* #ffffff */\n\n  --COLOR_FAILED: rgba(253, 162, 155, 1); /* #fda29b */\n  --COLOR_FAILED_25: rgba(217, 45, 32, 1); /* #d92d20 */\n  --COLOR_FAILED_50: rgba(180, 35, 24, 1); /* #b42318 */\n  --COLOR_FAILED_75: rgba(255, 251, 250, 1); /* #fffbfa */\n  --COLOR_FAILED_100: rgba(2, 121, 72, 1); /* #027948 */\n  --COLOR_FAILED_125: rgba(179, 35, 24, 1); /* #b32318 */\n\n  --COLOR_ERROR_50: rgba(254, 243, 242, 1); /* #fef3f2 */\n  --COLOR_ERROR_100: rgba(254, 228, 226, 1); /* #fee4e2 */\n  --COLOR_ERROR_500: rgba(240, 68, 56, 1); /* #f04438 */\n\n  --COLOR_SUCCESS_500: rgba(18, 183, 106, 1); /* #12b76a */\n\n  --COLOR_GRAY_HOVER: rgba(234, 234, 234, 1); /* #eaeaea */\n  --COLOR_GRAY_LIGHT: rgba(229, 229, 229, 1); /* #e5e5e5 */\n  --COLOR_GRAY_50: rgba(249, 250, 251, 1); /* #f9fafb */\n  --COLOR_GRAY_75: rgba(221, 222, 224, 1); /* #dddee0 */\n  --COLOR_GRAY_100: rgba(242, 244, 247, 1); /* #f2f4f7 */\n  --COLOR_GRAY_150: rgba(161, 167, 180, 1); /* #a1a7b4 */\n  --COLOR_GRAY_400: rgba(152, 162, 179, 1); /* #98a2b3 */\n  --COLOR_GRAY_500: rgba(102, 112, 133, 1); /* #667085 */\n  --COLOR_GRAY_500_LIGHT: rgba(102, 112, 133, 0.6); /* #667085 */\n  --COLOR_GRAY_600: rgba(71, 84, 103, 1); /* #475467 */\n  --COLOR_GRAY_800: rgba(29, 41, 57, 1); /* #1d2939 */\n  --COLOR_GRAY_900_EXTRALIGHT: rgba(16, 24, 40, 0.03); /* #101828; */\n  --COLOR_GRAY_900_LIGHT: rgba(16, 24, 40, 0.05); /* #101828; */\n  --COLOR_GRAY_900_HEAVY: rgba(16, 24, 40, 0.08); /* #101828; */\n  --COLOR_GRAY_900: rgba(16, 24, 40, 1); /* #101828 */\n\n  --SIZE_BORDER: 1px;\n  --SIZE_BORDER_THICK: 2px;\n  --SIZE_BORDER_FRAME: 4px;\n  --SIZE_TOP_LINE: 6px;\n  --MENU_MIN_WIDTH: 240px;\n  --MENU_MAX_WIDTH: 648px;\n  --CONTENT_MIN_WIDTH: 232px;\n  --CONTENT_MAX_WIDTH: 335px;\n  --FORM_MAX_WIDTH: 358px;\n  --PAGE_MAX_WIDTH: 435px;\n  --TEXT_MAX_WIDTH: 472px;\n  --MODAL_MAX_WIDTH: 500px;\n  --DROPDOWN_MIN_WIDTH: 512px;\n  --MODAL_MOBILE: 80vh;\n  --MAX_VIEW_HEIGHT: 100vh;\n  --MAX_VIEW_WIDTH: 100vw;\n\n  --BORDER_PRIMARY: 1px solid rgba(208, 213, 221, 1);\n\n  --SIZE_1: 1px;\n  --SIZE_2: 2px;\n  --SIZE_4: 4px;\n  --SIZE_5: 5px;\n  --SIZE_6: 6px;\n  --SIZE_8: 8px;\n  --SIZE_9: 9px;\n  --SIZE_10: 10px;\n  --SIZE_12: 12px;\n  --SIZE_15: 15px;\n  --SIZE_16: 16px;\n  --SIZE_17: 17px;\n  --SIZE_18: 18px;\n  --SIZE_20: 20px;\n  --SIZE_22: 22px;\n  --SIZE_24: 24px;\n  --SIZE_25: 25px;\n  --SIZE_26: 26px;\n  --SIZE_28: 28px;\n  --SIZE_30: 30px;\n  --SIZE_32: 32px;\n  --SIZE_33: 33px;\n  --SIZE_34: 34px;\n  --SIZE_36: 36px;\n  --SIZE_37: 37px;\n  --SIZE_40: 40px;\n  --SIZE_43: 43px;\n  --SIZE_44: 44px;\n  --SIZE_46: 46px;\n  --SIZE_48: 48px;\n  --SIZE_50: 50px;\n  --SIZE_60: 60px;\n  --SIZE_68: 68px;\n  --SIZE_70: 70px;\n  --SIZE_72: 72px;\n  --SIZE_76: 76px;\n  --SIZE_80: 80px;\n  --SIZE_88: 88px;\n  --SIZE_84: 84px;\n  --SIZE_90: 90px;\n  --SIZE_92: 92px;\n  --SIZE_96: 96px;\n  --SIZE_100: 100px;\n  --SIZE_101: 101px;\n  --SIZE_103: 103px;\n  --SIZE_112: 112px;\n  --SIZE_113: 113px;\n  --SIZE_120: 120px;\n  --SIZE_124: 124px;\n  --SIZE_142: 142px;\n  --SIZE_149: 149px;\n  --SIZE_158: 158px;\n  --SIZE_168: 168px;\n  --SIZE_171: 171px;\n  --SIZE_174: 174px;\n  --SIZE_190: 190px;\n  --SIZE_200: 200px;\n  --SIZE_206: 206px;\n  --SIZE_223: 223px;\n  --SIZE_230: 230px;\n  --SIZE_240: 240px;\n  --SIZE_259: 259px;\n  --SIZE_260: 260px;\n  --SIZE_275: 275px;\n  --SIZE_280: 280px;\n  --SIZE_290: 290px;\n  --SIZE_295: 295px;\n  --SIZE_296: 296px;\n  --SIZE_330: 330px;\n  --SIZE_378: 378px;\n  --SIZE_400: 400px;\n\n  --SIZE_90VW: 90vw;\n  --SIZE_90VH: 90vh;\n\n  --RADIUS_4: 4px;\n  --RADIUS_5: 5px;\n  --RADIUS_6: 6px;\n  --RADIUS_8: 8px;\n  --RADIUS_10: 10px;\n  --RADIUS_12: 12px;\n  --RADIUS_16: 16px;\n  --RADIUS_20: 20px;\n  --RADIUS_28: 28px;\n  --RADIUS_40: 40px;\n  --RADIUS_50: 50px;\n\n  --MARGIN_2: 2px;\n  --MARGIN_3: 3px;\n  --MARGIN_4: 4px;\n  --MARGIN_6: 6px;\n  --MARGIN_7: 7px;\n  --MARGIN_8: 8px;\n  --MARGIN_9: 9px;\n  --MARGIN_10: 10px;\n  --MARGIN_11: 11px;\n  --MARGIN_12: 12px;\n  --MARGIN_14: 14px;\n  --MARGIN_16: 16px;\n  --MARGIN_17: 17px;\n  --MARGIN_18: 18px;\n  --MARGIN_20: 20px;\n  --MARGIN_23: 23px;\n  --MARGIN_24: 24px;\n  --MARGIN_25: 25px;\n  --MARGIN_28: 28px;\n  --MARGIN_29: 29px;\n  --MARGIN_30: 30px;\n  --MARGIN_32: 32px;\n  --MARGIN_36: 36px;\n  --MARGIN_38: 38px;\n  --MARGIN_40: 40px;\n  --MARGIN_44: 44px;\n  --MARGIN_50: 50px;\n  --MARGIN_56: 56px;\n  --MARGIN_60: 60px;\n  --MARGIN_76: 76px;\n  --MARGIN_116: 116px;\n\n  --PADDING_1: 1px;\n  --PADDING_2: 2px;\n  --PADDING_3: 3px;\n  --PADDING_4: 4px;\n  --PADDING_5: 5px;\n  --PADDING_6: 6px;\n  --PADDING_7: 7px;\n  --PADDING_8: 8px;\n  --PADDING_9: 9px;\n  --PADDING_10: 10px;\n  --PADDING_11: 11px;\n  --PADDING_12: 12px;\n  --PADDING_13: 13px;\n  --PADDING_14: 14px;\n  --PADDING_15: 15px;\n  --PADDING_16: 16px;\n  --PADDING_17: 17px;\n  --PADDING_18: 18px;\n  --PADDING_19: 19px;\n  --PADDING_20: 20px;\n  --PADDING_23: 23px;\n  --PADDING_24: 24px;\n  --PADDING_25: 25px;\n  --PADDING_26: 26px;\n  --PADDING_28: 28px;\n  --PADDING_29: 29px;\n  --PADDING_30: 30px;\n  --PADDING_32: 32px;\n  --PADDING_34: 34px;\n  --PADDING_40: 40px;\n  --PADDING_42: 42px;\n  --PADDING_46: 46px;\n  --PADDING_48: 48px;\n  --PADDING_54: 54px;\n  --PADDING_60: 60px;\n  --PADDING_67: 67px;\n  --PADDING_89: 89px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
